import { render, staticRenderFns } from "./VxCellPlayerAvatar.vue?vue&type=template&id=53610966&"
import script from "./VxCellPlayerAvatar.vue?vue&type=script&lang=js&"
export * from "./VxCellPlayerAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports